/* eslint-disable camelcase */
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchemaEditPickFromRegister = () => {
  const { t } = useTranslation();

  const requiredMessage = t('common:validationMessages.required');

  const createInvoiceAddressSchema = yup.object().shape({
    invoiceAddress: yup
      .object()
      .shape({
        invoiceAddress_id: yup.number(),
        name: yup.string(),
        address: yup.string(),
        postalcode: yup.string(),
        city: yup.string(),
        country: yup.string(),
        address2: yup.string(),
        email: yup.string(),
        name2: yup.string().nullable(),
      })
      .required(requiredMessage),
    invoiceReference: yup.string().required(requiredMessage),
    name: yup.string().required(requiredMessage),
    address: yup.string().required(requiredMessage),
    postalcode: yup.string().required(requiredMessage),
    city: yup.string().required(requiredMessage),
    country: yup.string().optional(),
    address2: yup.string().optional(),
    email: yup.string().optional(),
    name2: yup.string().optional(),
  });
  return createInvoiceAddressSchema;
};
